/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_ElevatorInputs */

const cs_form_has_elevator = /** @type {(inputs: Form_Has_ElevatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výtah`)
};

const en_form_has_elevator = /** @type {(inputs: Form_Has_ElevatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevator`)
};

/**
* | output |
* | --- |
* | "Elevator" |
*
* @param {Form_Has_ElevatorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_elevator = /** @type {((inputs?: Form_Has_ElevatorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_ElevatorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_elevator(inputs)
	return cs_form_has_elevator(inputs)
});